import React from 'react';
import CharStyle from 'components/Toolbar/Controls/CharStyle';
import ClearFormatting from 'components/Toolbar/Controls/ClearFormatting';
import Link from 'components/Toolbar/Controls/Link';
import ScriptStyle from 'components/Toolbar/Controls/ScriptStyle';
import ControlGroup from 'components/Toolbar/Shared/ControlGroup';
import * as Constants from 'const';
import { Priority } from 'hooks/useClickOutside/constants';
import { intlGet } from 'utils/intlGet';
import BaseToolbar from '../BaseToolbar';

type Props = {
  className?: string;
  disableLink: boolean;
  fontStyles: string[];
  layoutId: string;
  link: string;
  priority?: Priority;
  showTitle?: boolean;
  renderViaPortal?: boolean;
  clearFormatting: () => void;
  toggleCharStyle: (style: Constants.CharStyle) => void;
  toggleScriptStyle: (style: Constants.ScriptType) => void;
  toggleLink: (link: string) => void;
};

const Toolbar: React.FunctionComponent<Props> = (props) => {
  const {
    className,
    disableLink,
    fontStyles,
    layoutId,
    link,
    showTitle = true,
    renderViaPortal = true,
    clearFormatting,
    toggleCharStyle,
    toggleScriptStyle,
    toggleLink,
    priority,
  } = props;
  const title = showTitle ? intlGet('EditorToolbar.Asset', 'ReferenceCitation') : undefined;

  return (
    <BaseToolbar
      className={className}
      title={title}
      layoutId={layoutId}
      renderViaPortal={renderViaPortal}
      dataTestId="referenceCitation-baseToolbar"
    >
      <ControlGroup dataTestId="controlGroup-charScriptClearFormatting">
        <CharStyle
          activeStyles={fontStyles as Constants.CharStyle[]}
          onToggle={toggleCharStyle}
          dataTestId='referenceCitation-charStyleControl'
        />
        <ScriptStyle
          styles={fontStyles}
          toggleScriptStyle={toggleScriptStyle}
          dataTestId='referenceCitation-scriptStyleControl'
        />
        <ClearFormatting clearFormatting={clearFormatting} dataTestId="referenceCitation-clearFormatting" />
      </ControlGroup>
      <ControlGroup dataTestId="controlGroup-link">
        <Link
          isDisabled={disableLink}
          link={link}
          toggleLink={toggleLink}
          enableInternalLinks={false}
          priority={priority}
          dataTestId="referenceCitation-link"
        />
      </ControlGroup>
    </BaseToolbar>
  );
};

export default Toolbar;
